var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.items),function({ value, text, property }){return _c('v-list-item',{key:`${property}-${value}`,on:{"click":function($event){return _vm.emitFilter(property, value)}}},[_c('v-list-item-title',[_vm._v(" "+_vm._s(text)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }